import { useEffect } from 'react';

export const useSegmentTrackPage = (pathname) => {
  let analytics;
  if (global.BROWSER) {
    analytics = window?.segment;
  }
  useEffect(() => {
    if (analytics) {
      analytics.page();
    }
  }, [analytics, pathname]);
};
